import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=33f429d4&scoped=true"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"
import style0 from "./Heading.vue?vue&type=style&index=0&id=33f429d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f429d4",
  null
  
)

export default component.exports